export function persistReducer(state) {
    return {
        auth: {
            loggedUser: null,
            accessToken: state.auth.accessToken
        },
        currencies: state.currencies,
        currency : state.currency,
        locale: state.locale,
        adCar: state.adCar,
        buildTime: state.buildTime,
        appVersion: state.appVersion,
        appName: state.appName,
        uiConf: state.uiConf
    };
}
